export default {
  companyRoadmapsMetadata: {
    name: 'Name',
    team: 'Team',
    countNew: 'New',
    countInProgress: 'In progress',
    countDone: 'Done',
    countOverdue: 'Overdue',
    progress: 'Progress',
    link: 'Go to the board',
    noResults:
      'There are no results yet.<br/>To get the data, employees need to add tasks from development plans to the board manually.<br/>Tasks are automatically output only from development plans by 360 from the «Obvious growth areas» block.',
  },
};
